import { formatPhoneNumber } from '@ztechapps/common.utils'
import type { CountryCode } from 'libphonenumber-js/max'

export type PhoneNumberDisplayProps = {
  value: string
  countryCode?: CountryCode
}

export const PhoneNumberDisplay = ({ countryCode, ...props }: PhoneNumberDisplayProps) => {
  const customCode = countryCode ?? 'US'

  return formatPhoneNumber(props.value, customCode)
}
